import { useState } from 'react';
import Modal from '../../common/modal/Modal';
import Button from '../../ui/Button';
import styles from './style.module.scss';
import BuyVoucherSuceessModal from '../buy-voucher-success-dialog';
import { VoucherValueIcon, WalletIcon } from '../../../assets/Icon';

type BuyVoucherProps = {
  open: boolean;
  onClose: () => void;
};

const BuyVoucherModal = ({ onClose, open }: BuyVoucherProps) => {
  const [voucherSuccess, setVoucherSuccess] = useState(false);
  return (
    <>
      <BuyVoucherSuceessModal
        open={voucherSuccess}
        onClose={() => setVoucherSuccess(false)}
      />
      <Modal open={open} onClose={onClose} isCloseIconVisible={false}>
        <div className={styles.wrapper}>
          <p className={styles.title}>
            Do you want to Buy Voucher of LunchBox@99?
          </p>
          <div className={styles.voucherValue}>
            <VoucherValueIcon size={35} /> <strong>100</strong>
          </div>
          <div className={styles.walletBalanceWrapper}>
            <div>
              <div className={styles.leftContent}>
                <WalletIcon size={24} color="#685FD3" />
              </div>
              <div className={styles.rightContent}>
                <label>Your Wallet Balance</label>
                <span> 4,686</span>
              </div>
            </div>
          </div>
          <div className={styles.actions}>
            <Button variant="outline" onClick={onClose}>
              Reject
            </Button>
            <Button
              variant="dark"
              onClick={() => {
                onClose();
                setVoucherSuccess(true);
              }}
            >
              Yes, Buy it
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default BuyVoucherModal;
